class InfiniteScroll extends HTMLElement {
  connectedCallback() {
    this.productList = document.getElementById(this.getAttribute("list-id"));
    this.nextPageLink = this.querySelector('a[rel="next"]');

    if (!this.productList || !this.nextPageLink) {
      return;
    }

    this.querySelector(".pagination")?.setAttribute("hidden", "");
    this.loader = this.querySelector(".infinite-scroll__loader");
    this.onScroll = this.loadNextPageIfNeeded.bind(this);
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onScroll, { passive: true });

    if (document.readyState === "complete") {
      this.onScroll();
    } else {
      window.addEventListener("load", this.onScroll, { once: true });
    }
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onScroll);
    window.removeEventListener("load", this.onScroll);
  }

  loadNextPageIfNeeded() {
    if (this.getBoundingClientRect().top <= window.innerHeight + 800) {
      this.loadNextPage();
    }
  }

  async loadNextPage() {
    if (this.loading || !this.nextPageLink) {
      return;
    }

    this.loading = true;
    this.loader?.removeAttribute("hidden");

    try {
      const response = await fetch(this.nextPageLink.href);

      if (!response.ok) {
        return;
      }

      const nextPage = new DOMParser().parseFromString(
        await response.text(),
        "text/html",
      );
      const nextProductList = nextPage.getElementById(
        this.getAttribute("list-id"),
      );
      const nextPagination = nextPage.getElementById(this.id);

      if (!nextProductList || !nextPagination) {
        return;
      }

      const nextItems = Array.from(nextProductList.children);

      nextItems.forEach((item) => item.removeAttribute("reveal-on-scroll"));
      this.productList.append(...nextItems);
      this.replaceChildren(...nextPagination.childNodes);
      this.querySelector(".pagination")?.setAttribute("hidden", "");
      this.loader = this.querySelector(".infinite-scroll__loader");
      this.nextPageLink = this.querySelector('a[rel="next"]');

      if (!this.nextPageLink) {
        this.disconnectedCallback();
      }
    } finally {
      this.loading = false;
      this.loader?.setAttribute("hidden", "");
      this.loadNextPageIfNeeded();
    }
  }
}

if (!window.customElements.get("infinite-scroll")) {
  window.customElements.define("infinite-scroll", InfiniteScroll);
}
